import Vue from 'vue';

export default {
  methods: {
    handleCalendarScroll() {
      let currentFixedHeader = null;
      let currentGhost = null;

      $(document).scroll(() => {
        $.fn.reverse = [].reverse;

        const createGhostHeader = function (header, topOffset) {
          topOffset -= 163;
         // Don't recreate if it is the same as the current one
          if (header === currentFixedHeader && currentGhost) {
            currentGhost.css('top', `${-topOffset}px`);
            return currentGhost;
          }

          if (currentGhost) {
            $(currentGhost).remove();
          }

          const realTable = $(header).parents('table');

         // var headerPosition = $(header).offset();
          const tablePosition = $(realTable).offset();

          const container = $('<table id="new-table"></table>');

         // Copy attributes from old table (may not be what you want)
          for (let i = 0; i < realTable[0].attributes.length; i++) {
            const attr = realTable[0].attributes[i];
            container.attr(attr.name, attr.value);
          }

         // Set up position of fixed row
          container.css({
            position: 'fixed',
            top: -topOffset,
            left: tablePosition.left,
            width: $(realTable).outerWidth(),
            'z-index': 4,
          });

          container.addClass('calendar-scrolled-header');

         // Create a deep copy of our actual header and put it in our container
          const newHeader = $(header).clone().appendTo(container);

          const collection2 = $(newHeader).find('td');

          $(header).find('td').each(function () {
            const matchingElement = $(collection2.eq($(this).index()));
            $(matchingElement).width($(this).width() + 0.5);
          });

          currentGhost = container;
          currentFixedHeader = header;

         // Add this fixed row to the same parent as the table
          $(table).parent().append(currentGhost);
          return currentGhost;
        };

        const currentScrollTop = $(document).scrollTop();

        let activeHeader = null;
        let table = $('#table_calendar');

        const tablePosition = table.offset();
        const tableHeight = table.height();

        const lastHeaderHeight = $(table).find('thead').last().height();
        let topOffset = 0;
        if (!tablePosition) {
          return false;
        }

        // Check that the table is visible and has space for a header
        if (((tablePosition.top + tableHeight) - lastHeaderHeight >= currentScrollTop) && (currentScrollTop > 200)) {
          let lastCheckedHeader = null;

          // We do these in reverse as we want the last good header
          $(table).find('thead').reverse().each(function () {
            const position = $(this).offset();
            position.top -= 170;
            if (position.top <= currentScrollTop) {
              activeHeader = this;
              return false;
            }

            lastCheckedHeader = this;
          });

          if (lastCheckedHeader) {
            const offset = $(lastCheckedHeader).offset();
            if (offset.top - currentScrollTop < $(activeHeader).height()) {
              topOffset = ($(activeHeader).height() - (offset.top - currentScrollTop)) + 1;
            }
          }
        }

        // No row is needed, get rid of one if there is one
        if (activeHeader == null && currentGhost) {
          currentGhost.remove();
          currentGhost = null;
          currentFixedHeader = null;
        }

        // We have what we need, make a fixed header row
        if (activeHeader) {
          createGhostHeader(activeHeader, topOffset);
        }
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/mixins/calendarScroll.js